export const getMinimizedNotesPopup = candidateNotesObj => {
  const candidateNotesArray = Object.entries(candidateNotesObj).map(([id, data]) => {
    return { ...data, Id: id };
  });
  return candidateNotesArray.filter(note => note.minimized);
};
